/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { UserOutlined, LogoutOutlined } from '@ant-design/icons'
import { paragraphSmallStyle } from '../steps/Main'

interface LoggedUserBarProps {
  email: string
  onStartOver: () => void
  disabled?: boolean
}

/**
 * 🔄 LoggedUserBar: Displays logged user email and start over option
 * Extracted from TeamRegister for reusability across registration screens
 */
const LoggedUserBar: React.FC<LoggedUserBarProps> = ({
  email,
  onStartOver,
  disabled = false,
}) => {
  return (
    <div
      css={css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-self: stretch;
        margin-top: 16px;
        margin-bottom: -8px;
        @media (max-width: 768px) {
          flex-direction: row;
          width: 100%;
          gap: 8px;
        }
      `}
    >
      <a
        css={css`
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: default;
        `}
        target='_blank'
        rel='noreferrer'
      >
        <UserOutlined
          css={css`
            color: ${colors.PRIMARY};
          `}
        />
        <p
          css={css`
            ${paragraphSmallStyle}
            color: ${colors.PRIMARY};
          `}
        >
          {email}
        </p>
      </a>
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: ${disabled ? 'not-allowed' : 'pointer'};
          opacity: ${disabled ? 0.5 : 1};
          pointer-events: ${disabled ? 'none' : 'auto'};
        `}
        aria-disabled={disabled}
        title={disabled ? 'Payment in progress – cannot start over' : undefined}
        onClick={disabled ? undefined : onStartOver}
      >
        <LogoutOutlined
          css={css`
            color: ${colors.ERROR_200};
          `}
        />
        <p
          css={css`
            ${paragraphSmallStyle}
            color: ${colors.ERROR_200};
          `}
        >
          Start Over
        </p>
      </div>
    </div>
  )
}

export default LoggedUserBar
